import { useState } from "react";
import {
  banckTansfer,
  cashIcon,
  check,
  checkButton,
  checkIcon,
} from "../../asset";
import { useNavigate, useParams } from "react-router-dom";

const paymentType = [
  {
    icon: banckTansfer,
    type: "Bank Transfer ( Manual Process )",
    description:
      "If you select this option, you are required to manually pay your employee through your bank's website",
  },
  {
    icon: checkIcon,
    type: "Cheque",
  },
  {
    icon: cashIcon,
    type: "Cash",
  },
];

export default function PaymentInformation({ onBack }: { onBack: () => void }) {
  const [selected, setSelected] = useState<number | null>(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleCompletePayroll = () => {
    if (!id) return;

    sessionStorage.setItem(
      `payroll-progress-${id}`,
      JSON.stringify({
        completed: true,
        lastPage: "overview",
      }),
    );

    navigate(`/payroll/staff-overview/${id}`, { replace: true });
  };

  return (
    <div className="rounded-lg p-2 flex flex-col gap-2">
      <p>
        How would you like to pay your employee?{" "}
        <span className="text-error-600">*</span>
      </p>
      <div className="grid gap-5">
        {paymentType?.map((item, i) => {
          const isSelected = selected === i;
          return (
            <div
              key={i}
              onClick={() => setSelected(i)}
              className="bg-white p-[14px] cursor-pointer flex items-center justify-between pr-6 rounded-lg"
            >
              <div className="flex items-center gap-4">
                <img src={item.icon} alt="" className="w-12 h-12" />
                <div className="flex flex-col">
                  <p className="text-base text-neutral-400 font-medium">
                    {item.type}
                  </p>
                  <p className="text-xs text-neutral-300">{item.description}</p>
                </div>
              </div>
              <button
                className={`w-9 h-9 ${!isSelected ? "border border-neutral-200 " : "bg-primary-600"} rounded-full flex items-center justify-center`}
              >
                <img src={!isSelected ? checkButton : check} alt="" />
              </button>
            </div>
          );
        })}
      </div>
      <div className="flex justify-end gap-2 mt-5">
        <button
          onClick={onBack}
          className="px-6 py-[6px] border border-neutral-400 text-neutral-400 rounded-lg text-[13px] font-medium"
        >
          Cancel
        </button>
        <button
          onClick={handleCompletePayroll}
          className="px-3 py-[6px] bg-success-700 text-white rounded-lg text-[13px] font-medium"
        >
          Save and Continue
        </button>
      </div>
    </div>
  );
}
